/**
 * Replaces any character that is not a number or a letter (case-insensitive)
 * @param string
 */
export function filterEverythingExceptNumbersAndLetters(string: string) {
  return string.replace(/[^A-Za-z0-9]+/g, '')
}

/**
 * Asserts whether the given URL is valid
 */
export function checkIfUrlIsValid(urlToCheck: string) {
  let isValid = false

  try {
    // step 1 - throw error if url cannot be transformed
    new URL(urlToCheck)

    // step 2 - manually check url against a stricter regex pattern
    const validURLPattern = new RegExp(
      '^(https?:\\/\\/)?' + // protocol
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
      '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
      '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
      '(\\#[-a-z\\d_]*)?$', // fragment locator
      'i',
    )

    isValid = validURLPattern.test(urlToCheck)
  } catch (_e) {
    // catches error, isValid already set to false
  }

  return isValid
}
